import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=2db52079&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=ts"
export * from "./NavHeader.vue?vue&type=script&lang=ts"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=2db52079&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db52079",
  null
  
)

export default component.exports